import type { InputHTMLAttributes, ReactNode, Ref } from 'react';
import styles from './Switch.module.css';

export interface SwitchProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'role' | 'size'> {
  /** Visible label. Without it, pass `aria-label`. */
  label?: ReactNode;
  description?: ReactNode;
  ref?: Ref<HTMLInputElement>;
}

/** On/off toggle for settings that apply immediately (checkbox with `role="switch"`). */
export function Switch({ label, description, className, ...rest }: SwitchProps) {
  const control = (
    <span className={styles.track}>
      <input type="checkbox" role="switch" className={styles.input} {...rest} />
      <span className={styles.thumb} aria-hidden="true" />
    </span>
  );
  if (!label) return control;
  return (
    <label className={[styles.row, className].filter(Boolean).join(' ')}>
      <span className={styles.text}>
        <span className={styles.label}>{label}</span>
        {description && <span className={styles.description}>{description}</span>}
      </span>
      {control}
    </label>
  );
}
